import {Component, ElementRef, ViewChild, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';


@Component({
  selector: 'exg-select',
  templateUrl: './exg-select.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: ExgSelectComponent, multi: true
  }]
})
export class ExgSelectComponent implements ControlValueAccessor {

  @ViewChild('selectInput') selectInput!: ElementRef;

  @Input() caption!: string;
  @Input() disabled!: string;
  @Input() list: Array<any> = [];
  @Input() listdisplay!: string;


  closed = false;

  _value: any = null;
  get value(): any {
    return this._value;
  }

  set value(obj: any) {

    this._value = obj;
    if (!this.list[obj]) {
      this._value = null;
    }
    this.onChange(this._value);
    this.onTouched(this._value);
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor() {
  }

  // ControlValueAccessor -> OUT
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ControlValueAccessor <- IN
  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {

    this._value = obj;
  }

  // ---------------


  public get displayValue(): any {
    if (this.listdisplay) {
      if (this.list[this.value]) {
        return this.list[this.value][this.listdisplay];
      } else {
        return null;
      }
    } else {
      if (this.list[this.value]) {
        return this.list[this.value];
      } else {
        return null;
      }
    }
  }

  public displayItem(item: any): any {
    if (this.listdisplay) {
      if (item) {
        return item[this.listdisplay];
      } else {
        return '-';
      }
    } else {
      if (item) {
        return item;
      } else {
        return '-';
      }
    }
  }


  setFocus(): void {
    if (this.list[this.value]) {
      this.selectInput.nativeElement.focus();
    }
  }

  mouseDown(event?: MouseEvent): void {
    this.closed = !this.closed;
  }

  change(newValue: any): void {
    this.value = newValue;
  }

}
